import { useQuery } from "@tanstack/react-query";
import type { Attribute } from "@/lib/types"; // Import as type
import { API_BASE_URL } from "@/lib/api/config"; // Corrected import path

const fetchAttributes = async (): Promise<Attribute[]> => {
  const response = await fetch(`${API_BASE_URL}/api/attributes`);
  if (!response.ok) {
    throw new Error("Failed to fetch attributes");
  }
  const data = await response.json();
  return data.data; // Assuming the API returns { status: "success", data: [...] }
};

export const useAttributes = () => {
  return useQuery<Attribute[], Error>({
    queryKey: ["attributes"],
    queryFn: fetchAttributes,
    staleTime: Infinity, // Attributes are unlikely to change frequently
    gcTime: Infinity, // Changed from cacheTime to gcTime
  });
};
